export const MAXIMUM_CHARACTER_COUNT_WARNING = 'The maximum character count of this message has been reached.';